import Button from '@alltrails/shared/denali/components/Button';
import { verify } from 'api/Coupons';
import OutlinedTextField from 'components/forms/textFields/OutlinedTextField';
import TextButton from 'components/TextButton';
import useToggle from '@alltrails/shared/hooks/useToggle';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import Coupon from 'types/Coupon';
import PlanCode from 'types/PlanCode';

import * as styles from './CouponCode.module.scss';

// Desktop: https://www.figma.com/file/vJ30CAAm8qdbDO0j5C4Ce7/Web-Pro-Purchase-Flow

type Props = {
  coupon?: Coupon;
  setCoupon: (coupon: Coupon) => void;
  setPlanCode: (planCode: PlanCode) => void;
};

export default function CouponCode({ coupon, setCoupon, setPlanCode }: Props) {
  const [isOpen, toggle] = useToggle(Boolean(coupon));
  const [value, setValue] = useState(coupon?.code);
  const [hasError, setHasError] = useState(false);

  async function handleClick() {
    try {
      const coupons = await verify(value);

      // clear a previous bad coupon
      setHasError(false);

      setCoupon(coupons[0]);

      const params = new URLSearchParams(window.location.search);
      params.set('k', coupons[0].code);
      window.history.replaceState({}, '', `${window.location.pathname}?${params}`);

      setPlanCode(PlanCode.Annual);
    } catch (e) {
      setHasError(true);
    }
  }

  return isOpen ? (
    <div className={styles.content}>
      <div className={styles.coupon}>
        <OutlinedTextField
          changeHandler={e => setValue(e.target.value)}
          errorMessage={hasError && <FormattedMessage defaultMessage="This coupon code is invalid" />}
          isDisabled={Boolean(coupon)}
          isSuccess={Boolean(coupon)}
          label={<FormattedMessage defaultMessage="Coupon code" />}
          value={value}
        />
        <Button
          onClick={handleClick}
          testId="coupon"
          text={coupon ? <FormattedMessage defaultMessage="Applied" /> : <FormattedMessage defaultMessage="Apply" />}
          variant="default"
        />
      </div>
      <TextButton className={styles.button} onClick={toggle}>
        <FormattedMessage defaultMessage="Hide coupon code" />
      </TextButton>
    </div>
  ) : (
    <TextButton className={styles.button} onClick={toggle}>
      <FormattedMessage defaultMessage="Enter a coupon code" />
    </TextButton>
  );
}
